const getFormat = (format) => {
  const { symbol } = Shopify.countries.find(c => c.code == Shopify.currency.active);
  if (!symbol) {
    return "${{amount}}";
  }
  return `${symbol}{{amount}}`;
};

Shopify.money_format = getFormat();

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value;
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  const match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
};

const applyDiscountsToElement = (element, discounts) => {
  const productId = parseInt(element.dataset.productId);
  const variantId = parseInt(element.dataset.variantId);
  let applicableDiscounts = [];
  
  discounts.forEach((discount) => {
    if (discount.products) {
      const items = discount.products;
      const value = discount.amount;
      const percentage = discount.percentage;
      const minItems = discount.minimumRequirement;
      const rate = parseFloat(Shopify.currency.rate);
      items?.forEach((item) => {
        const id = parseInt(item.id.split("gid://shopify/Product/")[1]);
        
        if (id == productId && value && !percentage) {
          applicableDiscounts.push({
            value: parseFloat(value * rate),
            minItems: parseInt(minItems),
          });
        }
        if (id == productId && !value && percentage) {
          applicableDiscounts.push({
            percentage: parseFloat(percentage),
            minItems: parseInt(minItems),
          });
        }
      });
    }
  });

  element.setAttribute(
    "data-applicable-discounts",
    JSON.stringify(applicableDiscounts)
  );
};

const applyDiscounts = async () => {
  
  const path = window.location.hostname == 'www.punkbunnycoffee.com' ? "" : "/staging";
  const resp = await fetch("https://pbc-app.modeng.dev/api" + path)
    .then((response) => response.json())
    .then((data) => data);

  const {data} = resp;

  const discounts = data;

  const productEl = document.querySelector(".product-single");

  const productCards = document.querySelectorAll(".product-card");

  Shopify.discounts = discounts;

  if (productEl) {
    applyDiscountsToElement(productEl, discounts);
  }
  if (productCards) {
    productCards.forEach((productCard) => {
      const quantity = productCard.dataset.quantity;
      const productId = productCard.dataset.productId;
      const variantId = productCard.dataset.variantId;
      const productPrice = productCard.dataset.productPrice;
      let disc;

      discounts.forEach((discount) => {
        
        if (discount.products) {
          const items = discount.products;
          const value = discount.amount;
          const minItems =
            discount.minimumRequirement;
          const rate = parseFloat(Shopify.currency.rate);
          items?.forEach((item) => {
            const id = parseInt(item.id.split("gid://shopify/Product/")[1]);
            if (4 == minItems && id == productId) {
              const totalPrice = ((parseInt(minItems * productPrice)) - ((parseFloat(value) * 100) * rate));
              const fromPrice = Shopify.formatMoney(
                totalPrice / 4,
                Shopify.money_format
              );
              if(productCard.querySelector(".from-price")) {
                productCard.querySelector(".from-price").innerHTML = fromPrice;
              }
            }
            if (id == productId && value && quantity == minItems) {

              const money = Shopify.formatMoney(
                (quantity * productPrice) - ((parseFloat(value) * 100) * rate),
                Shopify.money_format
              );    
              productCard.querySelector("[data-final-price]").innerHTML = money;
            }
          });
        }
      });
    });
  }
};

//applyDiscounts();
